import { Button, LinkButton, Theme, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { ADD_ADVERTISING } from 'shared/constants/links';
import { useAppDispatch, useUrlWithUtm } from 'shared/hooks';
import { caPlaceAnAd } from '../tracking';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { setVisible } from 'shared/slices';
import { logoutUser } from 'shared/thunks/logout';
import { clsx } from 'clsx';

export const Header: React.FC = () => {
  const device = useDeviceType();

  const isPhone = device === 'phone';

  const btnSize = isPhone ? 'XS' : 'M';

  const {
    custom: { cianUserId },
  } = useApplicationContext();

  const dispatch = useAppDispatch();

  const advertisingUrl = useUrlWithUtm(ADD_ADVERTISING);

  const handleClickAuthBtn = () => {
    dispatch(cianUserId ? logoutUser() : setVisible(true));
  };

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['logo']} />
      <div className={styles['btns']}>
        <div className={styles['btn']}>
          <Theme theme="colored">
            <LinkButton
              href={advertisingUrl}
              fullWidth
              size={btnSize}
              theme="fill_secondary"
              target="_blank"
              onClick={caPlaceAnAd}
              rel="noopener noreferrer"
            >
              + Разместить объявление
            </LinkButton>
          </Theme>
        </div>
        <div className={styles['btn']}>
          <Button size={btnSize} theme="fill_white_primary" onClick={handleClickAuthBtn}>
            {cianUserId ? 'Выйти' : 'Войти'}
          </Button>
        </div>
      </div>
    </div>
  );
};
